import { getByID } from '@adornis/baseql/operations/mongo';
import { Base } from '@adornis/buildify/db/Base';
import { MarketingBuildifyGlobalSettings } from '@adornis/digitale-helden-shared/db/buildify/DigitaleHeldenBuildifyGlobalSettings';
import { CommentOnBuildify } from '@adornis/digitale-helden-shared/features/comments/client/CommentOnBuildify';
import { saveRawDraft } from '@adornis/digitale-helden-shared/features/drafts/api/saveRawDraft';
import { Draft } from '@adornis/digitale-helden-shared/features/drafts/db/Draft';
import { stateful } from '@adornis/functional-lit/stateful';
import { useQuery } from '@adornis/functional-lit/use-query';
import { goTo } from '@adornis/router/client/open-href';
import { html } from 'lit';
import { adminRouter } from '../../../client/admin/marketing-page-admin';
import { MarketingVisualizeBuildify } from './MarketingVisualizeBuildify';

export const EditPageDraft = stateful(({ draftID }: { draftID: string }) => {
  const _draft = useQuery(() => getByID<typeof Draft>(Draft, draftID)(Draft.allFields), [draftID]);
  const draft = _draft.value;
  if (_draft.loading || !draft || !(draft instanceof Draft)) return html` <d-text> Entwurf wird geladen... </d-text> `;

  const buildify = (mode: 'view' | 'edit') => {
    return html`
      ${MarketingVisualizeBuildify({
        entityData: draft,
        value: draft.entity.content as Base[],
        onNavigateBackCallback: () => {
          draft.revert();
          //adminRouter.goTo('review');
          goTo('/admin/review');
        },
        onSaveCallback: async () => {
          await saveRawDraft(draft)();
        },
        mode,
        addActionButtons: true,
      })}
    `;
  };

  if (draft.statusKey === 'IN_REVIEW' || draft.statusKey === 'IN_REVISION')
    return html`
      ${CommentOnBuildify({
        globalSettingsClassName: MarketingBuildifyGlobalSettings._class,
        buildifyContent: buildify(draft.statusKey === 'IN_REVIEW' ? 'view' : 'edit'),
        relatedEntityID: draftID,
        content: draft.entity.content,
        draft,
        onNavigateBackCallback: () => {
          adminRouter.goTo('review');
        },
      })}
    `;

  return html` ${buildify('edit')} `;
});
